import { Avatar, Box, Paper, styled, Typography } from '@mui/material';
import { Link } from 'react-router-dom';

export const StyleBox = styled(Box)({
  background: '#f9f9f9',
  padding: '0.2rem',
  marginTop: '0.4rem',
  borderRadius: '0.4rem'
});

export const StyleHeader = styled(Typography)(({ theme }) => ({
  marginTop: '0.6rem',
  textTransform: 'capitalize',
  fontWeight: theme.typography.fontWeightBold,
  fontSize: theme.typography.h6.fontSize,
  borderBottom: '2px solid #d3d3d3',
  borderRadius: '3px'
}));

export const StyledStrong = styled('strong')({
  color: '#88F231'
});

export const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: '#fff',
  boxShadow:
    '-1px 2px 6px 6px rgba(0, 0, 0, 0.2), 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 1px 3px 0px rgba(0, 0, 0, 0.12)',
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: 'center',
  color: theme.palette.text.secondary,
  ...theme.applyStyles('dark', {
    backgroundColor: '#1A2027'
  })
}));

export const LogoWrapper = styled(Box)({
  display: 'flex',
  border: '1px solid #f0f0f0',
  borderRadius: '0.8rem',
  padding: '0.62rem',
  justifyContent: 'space-between',
  alignItems: 'center'
});

export const VisuallyHiddenInput = styled('input')({
  clip: 'rect(0 0 0 0)',
  clipPath: 'inset(50%)',
  height: 1,
  overflow: 'hidden',
  position: 'absolute',
  bottom: 0,
  left: 0,
  whiteSpace: 'nowrap',
  width: 1
});

export const LogoFileLabel = styled(Typography)({
  marginTop: 0.4,
  marginLeft: 14,
  fontSize: '0.85rem',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  maxWidth: '224px'
});

export const DashboardWrapper = styled(Box)({
  overflowY: 'hidden',
  height: '92vh'
});

export const LeadTableWrapper = styled(Box)({
  height: '90vh',
  '.dash-card-body .table-responsive': {
    height: '75vh'
  }
});

export const StyledLabel = styled(Typography)(() => ({
  fontFamily: 'Montserrat',
  fontWeight: 600,
  fontSize: '0.75rem',
  lineHeight: '1.125rem',
  color: '#666666'
}));

export const IconWithLabel = styled(Avatar)(() => ({
  padding: '6px',
  marginLeft: '2px'
}));

export const ButtonAsLink = styled(Link)(() => ({
  display: 'inline-block',
  padding: 8,
  background: '#000',
  color: '#fff',
  borderRadius: '2rem',
  minWidth: '5rem',
  textDecoration: 'none',
  fontWeight: '500',
  textAlign: 'center',
  cursor: 'pointer',
  transition: 'background-color 0.2s',
  ':hover': {
    background: '#88F130',
    color: '#000'
  }
}));

export const StyledScrollableContainer = styled(Box)(({ theme }) => ({
  marginTop: theme.spacing(1),
  marginBottom: theme.spacing(1),
  display: 'block',
  backgroundColor: theme.palette.background.paper,
  overflow: 'auto',
  padding: '0.4rem',
  height: 'calc(100vh - 190px)',
  '.MuiPaper-root': {
    backgroundColor: '#fff',
    boxShadow: 'none'
  }
}));

export const StyledHelperMessageLabel = styled(Typography)({
  marginTop: 0.4,
  marginLeft: 1,
  fontSize: '0.85rem',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  maxWidth: '224px'
});
